"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pmakeUnit = void 0;
var IRConst_1 = require("../../../../IR/IRNodes/IRConst.js");
var Term_1 = require("../../../Term/index.js");
var types_1 = require("../../../type_system/types.js");
var pmakeUnit = function () { return new Term_1.Term(types_1.unit, function (_dbn) { return IRConst_1.IRConst.unit; }, true // isConstant
); };
exports.pmakeUnit = pmakeUnit;
